module.exports = __webpack_public_path__ + "static/media/irotate.01090b92.svg";